﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRates = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateRate_1 = require("./StateRate");
class StateRates extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Rates", true);
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateRate_1.StateRate);
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
            this.page.ctrls.btnNew.hide();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const rates = yield this.lockgui(this.app.api.admin.directory.getAllRates());
            if (!rates)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(rates);
            return _super.start.call(this);
        });
    }
    fill(rates) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = '';
            for (const rate of rates) {
                const item = new com.ListItem();
                item.ctrls.lType.text = "Rate";
                item.ctrls.lId.text = `#${rate.id}`;
                let data = [gs.text.clearHtmlToText(`${rate.name}`)];
                item.ctrls.pData.html = data.join('<br>');
                this.page.ctrls.list.append(item);
                item.onclick = () => gs_1.StateGS.Run(StateRate_1.StateRate, rate);
            }
        });
    }
}
exports.StateRates = StateRates;
StateRates.StateName = "rates";
//# sourceMappingURL=StateRates.js.map